const state = {
  showMainMenu: false,
  showDrawer: false,
  maindrawer: false,
  showBackButton: false,
  showUserMenu: false,
};
const getters = {
  getShowMainMenu: (State) => State.showMainMenu,
  getShowDrawer: (State) => State.showDrawer,
  isMainDrawer: (State) => State.maindrawer,
  getShowBackButton: (State) => State.showBackButton,
  getShowUserMenu: (State) => State.showUserMenu,
};
const actions = {
  enableMainMenu({ commit, State }) {
    console.debug('enableMainMenu');
    commit('setMainMenuStatus', true);
  },
  disableMainMenu({ commit, State }) {
    console.debug('disableMainMenu');
    commit('setMainMenuStatus', false);
  },
  toggleMainMenu({ commit, State }) {
    console.debug('toggleMainMenu', state.showMainMenu);
    commit('setMainMenuStatus', !state.showMainMenu);
  },
  enableDrawer({ commit, State }) {
    console.debug('enableDrawer');
    commit('setMainDrawer', true);
    commit('setDrawerStatus', false);
  },
  disableDrawer({ commit, State }) {
    console.debug('disableDrawer');
    commit('setMainDrawer', false);
  },
  toggleDrawer({ commit, State }) {
    console.debug('toggleDrawer', state.showDrawer);
    commit('setDrawerStatus', !state.showDrawer);
  },
  enableBackButton({ commit, State }) {
    console.debug('enableBackButton');
    commit('setBackButtonStatus', true);
  },
  disableBackButton({ commit, State }) {
    console.debug('disableBackButton');
    commit('setBackButtonStatus', false);
  },
  toggleBackButton({ commit, State }) {
    console.debug('toggleBackButton', state.showBackButton);
    commit('setBackButtonStatus', !state.showBackButton);
  },
  enableUserMenu({ commit, State }) {
    console.debug('enableUserMenu');
    commit('setUserMenuStatus', true);
  },
  disableUserMenu({ commit, State }) {
    console.debug('disableUserMenu');
    commit('setUserMenuStatus', false);
  },
  toggleUserMenu({ commit, State }) {
    console.debug('toggleUserMenu', state.showUserMenu);
    commit('setUserMenuStatus', !state.showUserMenu);
  },
};
const mutations = {
  setMainMenuStatus: (State, menuStatus) => {
      State.showMainMenu = menuStatus;
  },
  setDrawerStatus: (State, drawerStatus) => {
      State.showDrawer = drawerStatus;
  },
  setMainDrawer: (State, drawerStatus) => {
      State.maindrawer = drawerStatus;
  },
  setBackButtonStatus: (State, buttonStatus) => {
      State.showBackButton = buttonStatus;
  },
  setUserMenuStatus: (State, menuStatus) => {
      State.showUserMenu = menuStatus;
  },
};

export default {
  actions,
  mutations,
  getters,
  state,
};
